import flickitySlider from './components/_flickity-sliders'
import lazyLoad from './_lazyLoad'
import accordion from './classes/_accordion'
import dropdown from './_dropdown'
import toggleSidebar from './_toggleSidebar'
import wooSidebar from './_wooSidebar'
import tabs from './_tabs'
import wooLoadmore from './_woo-loadmore'
import './_mobileNav'

function init() {
  accordion()
  flickitySlider()
  lazyLoad()
  dropdown()
  toggleSidebar()
  tabs()
  wooSidebar()
  wooLoadmore()
}

init()



// WEBPACK FOOTER //
// ./src/js/main.js